<template>
  <div class="usageHistoryGraphRoot">
    <div class="tableMenu">
      <b-select
        placeholder="レポートの種類"
        icon="file"
        icon-pack="fas">
        <option value="all">すべて</option>
      </b-select>
    </div>
    <line-chart :datasets="data.datasets" :labels="data.labels" :graphOptions="graphOptions"/>
  </div>
</template>

<script >
import Vue from "vue";
import LineChart from "@/components/atoms/LineChart/index.vue";

export default Vue.extend({
  components: { LineChart },
  data() {
    return {
      graphOptions: {
        scales: {
          yAxes: [{
            id: "left-axis",
            type: "linear",
            position: "left",
            ticks: { beginAtZero: true },
            gridLines: { display: true },
          }, {
            id: "right-axis",
            type: "linear",
            position: "right",
            ticks: { beginAtZero: true, stepSize: 1000 },
            gridLines: { drawOnChartArea: false },
          }],
          xAxes: [{ gridLines: { display: false } }],
        },
        legend: { display: true },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          labels: [],
          datasets: [],
        };
      },
    },
    nextToken: {
      type: String,
    },
    QueryExecutionId: {
      type: String,
    },
  },
  methods: {
    handleOnSearch(val) {
      this.$emit("search", val);
    },
  },

});
</script>

<style lang="scss" scoped>
.usageHistoryGraphRoot {
  & .tableMenu {
    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }
}
</style>
